import { v4 as uuidv4 } from 'uuid'

export interface PatientFamilyDTO {
  id: string
  patientID: string
  familiarID: string
  relationship: string
  phone: string
}

export function emptyPatientFamily(patientID: string): PatientFamilyDTO {
  return {
    id: uuidv4(),
    patientID: patientID,
    familiarID: '',
    relationship: '',
    phone: '',
  }
}

export class PatientFamily {
  private readonly _id: string
  private readonly _patientID: string
  private readonly _familiarID: string
  private _relationship: string
  private _phone: string

  constructor(p: PatientFamilyDTO) {
    this._id = p.id
    this._patientID = p.patientID
    this._familiarID = p.familiarID
    this._relationship = p.relationship
    this._phone = p.phone
  }

  get id(): string {
    return this._id
  }

  get patientID(): string {
    return this._patientID
  }

  get familiarID(): string {
    return this._familiarID
  }

  get relationship(): string {
    return this._relationship
  }

  set relationship(value: string) {
    this._relationship = value
  }

  get phone(): string {
    return this._phone
  }

  set phone(value: string) {
    this._phone = value
  }

  toDTO(): PatientFamilyDTO {
    return {
      id: this.id,
      patientID: this.patientID,
      familiarID: this.familiarID,
      relationship: this.relationship,
      phone: this.phone,
    }
  }
}

export function toModel(d: PatientFamilyDTO): PatientFamily {
  return new PatientFamily(d)
}

export function fromModel(d: PatientFamily): PatientFamilyDTO {
  return {
    id: d.id,
    patientID: d.patientID,
    familiarID: d.familiarID,
    relationship: d.relationship,
    phone: d.phone,
  }
}
